<template>

    <div class="text-sm">

        <div class="flex flex-row justify-between items-start gap-x-8">

            <div class="flex flex-grow items-start flex-col">

                <div class="font-medium flex flex-grow items-center" :class="{ 'text-gray-400': !canToggleGdpr }"> GDPR
                    opt-in<br />
                    <span v-if="!canToggleGdpr" class="text-sm text-gray-400">Only available
                        <inertia-link v-if="$page.props.canManagePlan" :href="route('subscription.index')"
                            class="text-blue-500 hover:underline">on paid plans</inertia-link>
                        <span v-else class="text-gray-600">on paid plans</span>
                    </span>
                </div>

                <div class="text-sm mt-3">By enabling the GDPR opt-in, users will have to agree to your privacy policies
                    before any data can be sent from their browsers. This introduces one extra step to the usual flow.
                </div>

            </div>

            <div class="flex flex-shrink">
                <toggle :checked="privacy_policy_url" @click.prevent.stop @update="toggleGdpr"></toggle>
            </div>
        </div>


        <modal-privacy-policy-url ref="modalGdpr" @callback="toggleGdprResult"></modal-privacy-policy-url>

    </div>

</template>

<script>

import Toggle from '@/Components/UI/Toggle'
import ModalPrivacyPolicyUrl from '@/Components/Modals/PrivacyPolicyUrl'

export default {

    props: ['w_settings'],

    components: {
        Toggle, ModalPrivacyPolicyUrl
    },

    created: function () {

    },

    data() {
        return {
            canToggleGdpr: true,
            widget_settings: this.w_settings,
        }
    },

    mounted: function () {
    },

    methods: {
        toggleGdpr() {
            if (!this.canToggleGdpr) {
                return
            }
            if (this.privacy_policy_url) {
                this.toggleGdprResult({ url: null })
                return
            }
            this.$refs.modalGdpr.open()
        },
        toggleGdprResult(obj) {

            let url = this.$page.props.api_url + '/v1/settings/appearance';
            var params = {
                privacy_policy_url: obj.url,
            };
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated!", options)
                    }
                })
                .catch(e => {
                    console.error(e);
                });

            // if (this.privacy_policy_url) {
            //     this.widget_settings.privacy_policy_url = this.privacy_policy_url
            // } else {
            //     this.widget_settings.hide_zest_footer = "yes"
            // }
        }
    },

    computed: {
        privacy_policy_url() {
            if (this.widget_settings.privacy_policy_url) {
                return this.widget_settings.privacy_policy_url.length > 0
            }
            return false
        },
    }
}


</script>

<style scoped></style>
